const TedClockIcon = () => (
  <div>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8334 6.9974C12.8334 10.2174 10.2201 12.8307 7.00008 12.8307C3.78008 12.8307 1.16675 10.2174 1.16675 6.9974C1.16675 3.7774 3.78008 1.16406 7.00008 1.16406C10.2201 1.16406 12.8334 3.7774 12.8334 6.9974Z"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16418 8.85698L7.35585 7.77781C7.04085 7.59115 6.78418 7.14198 6.78418 6.77448V4.38281"
        stroke="#9E9E9E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
export default TedClockIcon;
